// export const API_URL = "https://api-dev.messengergo.app/api/v1/";
export const API_URL = "https://api.messengergo.app/api/v1/";
